import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Back, Next, ChatToAFitter } from '../ControlButtons';
import { SizeQuizExampleButton, SizeQuizButton } from '../selects/Buttons';
import { dataLayerGA4SizeQuizStageNumber } from '../../../shared/utils/data-layer';

const Stage7 = ({
  buttonSelected,
  defaultButtonProps,
  defaultNextProps,
  defaultPreviousProps,
  showPartTwo,
  partTwoButtonSelected,
  setPartTwoSelected,
  intl: { formatMessage },
  messages,
  stage7aData,
  stage7bData,
  setTempCupCache,
  cupSize,
  cupChange,
  resetCup,
  cachedCupSize,
}) => {
  const STAGE_NUMBER = '7';

  useEffect(() => {
    window.scrollTo(0, 0);
    dataLayerGA4SizeQuizStageNumber(STAGE_NUMBER);
  }, []);

  return (
    <div className="stageContainer">
      <div className="standardQuestionContainer">
        <Back
          {...defaultPreviousProps(
            1,
            formatMessage(messages.returnToBackResult)
          )}
          customFunc={() => {
            resetCup(cachedCupSize);
            setTempCupCache({ cupSize: cachedCupSize, cupChange: 0 });
          }}
        />
        <div className="stage stage-7">
          <div className="wrap wrap--left">
            <h4>{formatMessage(messages.stage7para1)}</h4>
            <SizeQuizExampleButton
              className="stage__tooltipBtn"
              message={formatMessage(messages.example)}
            />

            <div className="buttonsContainer">
              {stage7aData.map(({ func, text }, idx) => (
                <SizeQuizButton
                  key={idx}
                  {...defaultButtonProps(text, idx, func)}
                />
              ))}
            </div>
            {showPartTwo && (
              <>
                <h4>{formatMessage(messages.stage7bpara1)}</h4>
                <div className="buttonsContainer">
                  {stage7bData.map(({ func, text }, id) => (
                    <SizeQuizButton
                      key={id}
                      {...defaultButtonProps(text, id, func)}
                      partTwoSelected={partTwoButtonSelected}
                      setPartTwoSelected={setPartTwoSelected}
                    />
                  ))}
                </div>
              </>
            )}
            <Next
              hasChevron
              disabled={showPartTwo ? !partTwoButtonSelected : !buttonSelected}
              {...defaultNextProps(1, 'Next question')}
              customFunc={() => {
                setTempCupCache({ cupSize, cupChange });
              }}
            />
          </div>
        </div>
      </div>
      <hr className="contentDivider" />
      <div id="fittersAdvice" className="contentContainer">
        <h4 className="contentHeader">
          {formatMessage(messages.adviceFromABraFitterHeader)}
        </h4>
        <picture className="c-picture">
          <source
            srcSet="//images.ctfassets.net/bz0fvtkbk5r1/1GB61ApV16N9x1a0kC4IuY/1bd542d24eff98683ce7d804dccfcc3f/Shadow-band.jpg?q=80&amp;w=868&amp;fm=webp"
            type="image/webp"
          />
          <img
            alt="Why doesn't the centre of my bra lay flat against my chest?"
            src="//images.ctfassets.net/bz0fvtkbk5r1/1GB61ApV16N9x1a0kC4IuY/1bd542d24eff98683ce7d804dccfcc3f/Shadow-band.jpg?q=80&amp;w=868"
            className="c-image"
          />
        </picture>
        <p className="contentSubHeader">
          {formatMessage(messages.stage7para2)}
        </p>
        <ChatToAFitter stage={STAGE_NUMBER} />
      </div>
    </div>
  );
};

export default injectIntl(Stage7);

Stage7.propTypes = {
  Back: PropTypes.func,
  SizeQuizButton: PropTypes.func,
  buttonSelected: PropTypes.number,
  defaultButtonProps: PropTypes.func,
  defaultNextProps: PropTypes.func,
  defaultPreviousProps: PropTypes.func,
  SizeQuizExampleButton: PropTypes.func,
  goToStageEight: PropTypes.bool,
  intl: intlShape,
  messages: PropTypes.object,
  Next: PropTypes.func,
  stage7aData: PropTypes.array,
  stage7bData: PropTypes.array,
  showPartTwo: PropTypes.bool,
  setPartTwoSelected: PropTypes.func,
  partTwoButtonSelected: PropTypes.number,
  setTempCupCache: PropTypes.func,
  cupSize: PropTypes.string,
  tooltip: PropTypes.object,
  cupChange: PropTypes.number,
  resetCup: PropTypes.func,
  cachedCupSize: PropTypes.string,
};
